import { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { TyreModelVariant, TyreRatingBox, TyreDescription, TyreVariantBox } from ".";
import { PopularCarBrands } from "@/components/vehicle";
import { PopularTyreBrands } from '@/components/tyre';
import { HeaderBack } from '@/components/common/header';
import { _modelName, _getAllTyreModelVariant, _getAllTyreTopList, _getAllVehicleTopList, _getUserTyreReview, _convertRatingAverage, _convertRatingAveragePercentage, _getPlacement, removeIsWebviewPath } from "../../libraries/common";
import { getCookie, hasCookie } from "cookies-next";
import Redux from "@/action";
import Link from "next/link";
import { useRouter } from "next/router";
import { Footer } from "../common/footer";
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { LoginModal } from "../modal";
import { Progress, Skeleton } from "@mantine/core";
import { SkeletonParagraph } from "../common/skeleton";
import { useViewportSize, useScrollIntoView } from "@mantine/hooks";
import { colorBlueActiveCode, mobileViewWidth, pageLink, placementArea } from "../../config/site";
import { PlacementBanner } from '../../components/placement';
import { ExpendMore, IconStar } from "../common/icon";
import { TyreIcon } from '../../components/common/icon';
import { MyBody } from "../body/body";
import { CustomLink } from "../app/customLink";
import { customRouterLink } from "../../libraries/appCommon";

const TyreSpecBox = (props) => {
    const { t, label, input, image, displayBottom, scrollView = () => {}, imageType } = props

    return (
        <>
            <div className="vehicleModel_specItem">
                <div className="vehicleModel_specItem_left">
                    { imageType == 'image' ? <img className="w-100" src={image} /> : image }
                </div>
                <div className="vehicleModel_specItem_right">
                    <p className="fontSize_14 fontColor_lightGrey2">
                        {label}
                    </p>
                    <p className="fontSize_14 fontWeight_medium">
                        {input}
                    </p>
                    {
                        displayBottom && 
                        <div className="cursorPointer" style={{ padding: '0.5rem', borderRadius: '3rem', background: '#E91C21', width: '10.8rem', height: '3rem', display: 'none', alignItems: 'center', justifyContent: 'center' }} onClick={()=>scrollView()}>
                            <p className="fontSize_14 fontWeight_medium fontColor_white">{t('view_all_sizes')}</p>
                        </div>
                    }
                </div>
            </div>
        </>

    )
}

const TyreUserReviewSection = (props) => {
    const { fetchedData, userReviewList = [], t, router, loading = false, isLogin = {} } = props
    const [ratingDropdown, setRatingDropdown] = useState(false)

    // login 
    const [opened, setOpened] = useState(false)

    if(loading == true){
        return (
            <div className="vehicleUserReview containerPadding">
                <div className="vehicleUserReview_title">
                    <p className="fontSize_16 fontWeight_bold">
                        {`${fetchedData?.name} ${t('user_review')}`} 
                    </p>
                </div>
                <div className="vehicleUserReview_container">
                    <div className="vehicleUserReview_top">
                        <div className="vehicleUserReview_row1">
                            <p className="fontSize_16 fontWeight_medium fontColor_lightGrey3">
                                {t('ratings_reviews')}
                            </p>
                            <div className="fontSize_12 fontColor_grey2" style={{width: '10rem'}}>
                                <SkeletonParagraph row={1} />
                            </div>
                        </div>
                        <div className="vehicleUserReview_row2">
                            <div className="vehicleUserReview_row2_rating">
                                <div className="vehicleUserReview_row2_rating_num" style={{width: '5rem'}} >
                                    <SkeletonParagraph row={1} isTitle />
                                </div>
                                <div className="vehicleUserReview_row2_rating_star_iconList positionRelative" style={{width: '10rem', height: '1rem'}} >
                                    <div className="absoluteSkeletonBox">
                                        <Skeleton height={'100%'} radius={'5rem'} />
                                    </div>
                                </div>
                                <div onClick={()=>{setRatingDropdown(!ratingDropdown)}} className="vehicleUserReview_row2_rating_dropdown_icon">
                                    {/* TODOS icon color */}
                                    {
                                        ratingDropdown == false ?
                                        <img 
                                            src="/assets/images/expand_more.svg"
                                        />
                                        :
                                        <img 
                                            src="/assets/images/expand_up_icon.svg"
                                        />
                                    }
                                </div>
                            </div>
                            <div className="vehicleUserReview_row2_button positionRelative">
                                <div className="absoluteSkeletonBox">
                                    <Skeleton height={'100%'} radius={'5rem'} />
                                </div>
                            </div>
                        </div>
                        {
                            ratingDropdown == true &&
                            <div className="vehicleUserReview_row3">
                                <div className="vehicleUserReview_row3_left">
                                    {
                                        _.reduce([5,4,3,2,1], (result, value, key)=>{
                                            result.push(
                                                <div key={key} className="vehicleUserReview_row3_left_row">
                                                    <p className="fontSize_14 fontColor_grey2">
                                                        {value}
                                                    </p>
                                                    <SkeletonParagraph row={1} />
                                                </div>
                                            )
                                            return result
                                        },[])
                                    }
                                </div>
                            </div>
                        }
                    </div>
                    <div className="vehicleUserReview_commandList">
                        {
                            _.times(3, (key)=>(
                                <div key={key} className="vehicleUserReview_commandItem">
                                    <div className="vehicleUserReview_commandItem_header">
                                        <div className="fontSize_12 fontWeight_semiBold" style={{width: '10rem'}}>
                                            <SkeletonParagraph row={1} isTitle />
                                        </div>
                                        <div className="fontSize_12 fontColor_grey2">
                                            <SkeletonParagraph row={1} isDate />
                                        </div>
                                    </div>
                                    <div className="vehicleUserReview_commandItem_ratingList positionRelative">
                                        <div className="absoluteSkeletonBox">
                                            <Skeleton height={'100%'} radius={'5rem'} />
                                        </div>
                                    </div>
                                    <div className="vehicleUserReview_commandItem_description">
                                        <SkeletonParagraph row={2} />
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        )
    }
    return (
        <>
            <div className="vehicleUserReview containerPadding">
                <div className="vehicleUserReview_title">
                    <p className="fontSize_16 fontWeight_bold">
                        {`${fetchedData?.name} ${t('user_review')}`} 
                    </p>
                </div>
                <div className="vehicleUserReview_container">
                    <div className="vehicleUserReview_top">
                        <div className="vehicleUserReview_row1">
                            <p className="fontSize_16 fontWeight_medium fontColor_lightGrey3">
                                {t('ratings_reviews')}
                            </p>
                            <p className="fontSize_12 fontColor_grey2">
                                {`${userReviewList?.total_rating ?? 0} ${t('ratings')}`}
                            </p>
                        </div>
                        <div className="vehicleUserReview_row2">
                            <div className="vehicleUserReview_row2_rating">
                                <div className="vehicleUserReview_row2_rating_num">
                                    <p className="fontSize_25 fontWeight_bold">
                                        {_convertRatingAverage(userReviewList?.total_rating ?? 0, userReviewList?.total_review ?? 0)}
                                    </p>
                                    <p className="fontSize_10 vehicleUserReview_row2_rating_num_text">
                                        / 5
                                    </p>
                                </div>
                                <div className="vehicleUserReview_row2_rating_star_iconList">
                                    {
                                        _.reduce([1,2,3,4,5],(result, value, key)=>{
                                            result.push(
                                                <div key={key} className="vehicleUserReview_row2_rating_star_icon">
                                                    <IconStar  color={_convertRatingAverage(userReviewList?.total_rating ?? 0, userReviewList?.total_review ?? 0) >= value ? "#FFC327" : undefined} />
                                                </div>
                                            )
                                            return result
                                        },[])
                                    }
                                </div>
                                <div onClick={()=>{setRatingDropdown(!ratingDropdown)}} className="vehicleUserReview_row2_rating_dropdown_icon cursorPointer">
                                    {/* TODOS icon color */}
                                    {
                                        ratingDropdown == false ?
                                        <img 
                                            src="/assets/images/expand_more.svg"
                                        />
                                        :
                                        <img 
                                            src="/assets/images/expand_up_icon.svg"
                                        />
                                    }
                                </div>
                            </div>
                            <div onClick={()=>{isLogin == true ? customRouterLink({router: router, href: removeIsWebviewPath(router.asPath) + "/write-review"}) : setOpened(true) }} className="vehicleUserReview_row2_button cursorPointer">
                                <p className="fontSize_14 fontColor_white">
                                    {t('write_review')}
                                </p>
                            </div>
                        </div>
                        {
                            ratingDropdown == true &&
                            <div className="vehicleUserReview_row3">
                                <div className="vehicleUserReview_row3_left">
                                    {
                                        _.reduce([5,4,3,2,1], (result, value, key)=>{
                                            result.push(
                                                <div key={key} className="vehicleUserReview_row3_left_row">
                                                    <p className="fontSize_14 fontColor_grey2">
                                                        {value}
                                                    </p>
                                                    <div className="vehicleUserReview_row3_left_progress">
                                                        <Progress 
                                                            value={userReviewList?.total_review > 0 ? ((userReviewList?.group_rating?.[value]?.length / userReviewList?.total_review) * 100).toFixed(0) : 0}
                                                            color={"#FFC327"}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                            return result
                                        },[])
                                    }
                                </div>
                                <div className="vehicleUserReview_row3_right">
                                    <p className="fontSize_24 fontColor_grey2">
                                        {`${_convertRatingAveragePercentage(userReviewList?.total_rating ?? 0, userReviewList?.total_review ?? 0)}%`}
                                    </p>
                                    <p className="fontSize_12 fontColor_grey2">
                                        {t('recommended')}
                                    </p>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="vehicleUserReview_commandList">
                        {
                            _.reduce(userReviewList?.data, (result, value, key)=>{
                                if(key <= 2){
                                    result.push(
                                        <div key={key} className="vehicleUserReview_commandItem">
                                            <div className="vehicleUserReview_commandItem_header">
                                                <p className="fontSize_12 fontWeight_semiBold">
                                                    {value.full_name}
                                                </p>
                                                <p className="fontSize_12 fontColor_grey2">
                                                    {value.created_time}
                                                </p>
                                            </div>
                                            <div className="vehicleUserReview_commandItem_ratingList">
                                                {
                                                    _.reduce([1,2,3,4,5],(result2, value2, key2)=>{
                                                        result2.push(
                                                            <div key={`${key}-${key2}`} className="vehicleUserReview_row2_rating_star_icon" style={{ width: '2.2rem' }}>
                                                                <IconStar  color={value2 <= value.rating ? "#FFC327" : undefined} />
                                                            </div>
                                                        )
                                                        return result2
                                                    },[])
                                                }
                                            </div>
                                            <div className="vehicleUserReview_commandItem_description tyreReview_comment">
                                                <p className="fontSize_12">
                                                    {value.review}
                                                </p>
                                            </div>
                                            <div className="fontSize_10 tyreReviewCategoryBox">
                                                <div className="tyreReviewCategoryBox_inner">
                                                    <span>Dry grip and braking</span>
                                                    <span style={{ display: 'flex' }}>
                                                        {
                                                            _.reduce([1,2,3,4,5],(resultdrygrip, valuedrygrip, keydrygrip)=>{
                                                                resultdrygrip.push(
                                                                    <div key={keydrygrip} className="vehicleUserReview_row2_rating_star_icon">
                                                                        <IconStar  color={valuedrygrip <= value.drygrip_braking ? "#FFC327" : undefined} />
                                                                    </div>
                                                                )
                                                                return resultdrygrip
                                                            },[])
                                                        }
                                                    </span>
                                                </div>
                                                <div className="tyreReviewCategoryBox_inner">
                                                    <span>Wet grip and braking</span>
                                                    <span style={{ display: 'flex' }}>
                                                        {
                                                            _.reduce([1,2,3,4,5],(resultwetgrip, valuewetgrip, keywetgrip)=>{
                                                                resultwetgrip.push(
                                                                    <div key={keywetgrip} className="vehicleUserReview_row2_rating_star_icon">
                                                                        <IconStar  color={valuewetgrip <= value.wetgrip_braking ? "#FFC327" : undefined} />
                                                                    </div>
                                                                )
                                                                return resultwetgrip
                                                            },[])
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="fontSize_10 tyreReviewCategoryBox">
                                                <div className="tyreReviewCategoryBox_inner">
                                                    <span>Longevity</span>
                                                    <span style={{ display: 'flex' }}>
                                                        {
                                                            _.reduce([1,2,3,4,5],(resultlongevity, valuelongevity, keylongevity)=>{
                                                                resultlongevity.push(
                                                                    <div key={keylongevity} className="vehicleUserReview_row2_rating_star_icon">
                                                                        <IconStar  color={valuelongevity <= value.longevity ? "#FFC327" : undefined} />
                                                                    </div>
                                                                )
                                                                return resultlongevity
                                                            },[])
                                                        }
                                                    </span>
                                                </div>
                                                <div className="tyreReviewCategoryBox_inner">
                                                    <span>Silence and Comfort</span>
                                                    <span style={{ display: 'flex' }}>
                                                        {
                                                            _.reduce([1,2,3,4,5],(resultsilence, valuesilence, keysilence)=>{
                                                                resultsilence.push(
                                                                    <div key={keysilence} className="vehicleUserReview_row2_rating_star_icon">
                                                                        <IconStar  color={valuesilence <= value.silence_comfort ? "#FFC327" : undefined} />
                                                                    </div>
                                                                )
                                                                return resultsilence
                                                            },[])
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                return result
                            },[])
                        }
                    </div>
                    {
                        !_.isEmpty(userReviewList?.data) &&
                        <CustomLink href={removeIsWebviewPath(router.asPath) + "/review"}>
                            <div className="vehicleUserReview_viewMoreButtonMargin cursorPointer">
                                <div className="viewMore cursorPointer">
                                    <p className='fontSize_14 fontWeight_semiBold fontColor_blue'>
                                        {t('view_more')}
                                    </p>
                                    <div className="viewMore_icon">
                                        <ExpendMore color={colorBlueActiveCode} />
                                    </div>
                                </div>
                            </div>
                        </CustomLink>
                    }
                </div>
            </div>
            <LoginModal 
                opened={opened}
                setOpened={setOpened}
                t={t}
                isWriteReview={false}
                isWriteTyreReview={true}
            />
        </>
    )
}

export const TyreModel = (props) =>{
    const { t, fetchedData } = props
    const { store, dispatch } = Redux();
    const [loading, setLoading] = useState(true);
    const [viewMore, setViewMore] = useState(false);
    const [lineClamp, setLineClamp] = useState('2');

    // Tyre variant
    const [tyreVariant, setTyreVariant] = useState([]);

    const containerRef = useRef(null)

    // User data
    let userCookies;
    let isLogin;

    userCookies = getCookie("user") && JSON.parse(getCookie("user"));
    isLogin = !_.isEmpty(userCookies) ? true : false;

    // user review list
    const [userReviewList, setUserReviewList] = useState([]);
    const [userReviewTotal, setUserReviewTotal] = useState(0);

    const router = useRouter()
    const { width } = useViewportSize()

    const _setViewMore = () => {
        setLineClamp('unset');
        setViewMore(true);
    }

    const _scrollView = (value) => {
        const sectionTyreElement = document.querySelector(`.tyreVariantBox_sec`); // the modal class name 
        const sectionElement = document.querySelector(`.contentContainer`);
        const headerHeight = document.querySelector(`.tyreModel_tyreHeader`);

        const sectionTyreElementTop = sectionTyreElement.getBoundingClientRect().top;
        const headerHeightTop = headerHeight.getBoundingClientRect().top;
        const sectionElementTop = sectionElement.getBoundingClientRect().top;

        const scrollAmount = -(sectionElementTop + headerHeightTop) // - the header height 

        if(window.innerWidth <= mobileViewWidth){
            window.scrollTo({
                top:  sectionElementTop + sectionTyreElementTop + scrollAmount,
                behavior: 'smooth'
            });
        }
        else{
            sectionElement.scrollTo({
                top:  sectionElementTop + sectionTyreElementTop + scrollAmount,
                behavior: 'smooth'
            });
        }
    }

    useEffect(()=>{
        let isMounted = true; // Flag to track component mount status

        const fetchData = async()=>{
            try{
                await _getAllTyreModelVariant(setTyreVariant, {tyre_model_id: fetchedData?.tyre_model_id})

                if(store?.path?.dataAllTyreTopList == undefined){
                    await _getAllTyreTopList(dispatch);
                }

                if(store?.path?.dataAllVehicleTopList == undefined){
                    await _getAllVehicleTopList(dispatch);
                }

                if(store?.path?.dataPlacement == undefined){
                    await _getPlacement(dispatch)
                }

                await _getUserTyreReview(setUserReviewList, {brand_custom_url: fetchedData?.brand_custom_url,model_custom_url: fetchedData?.custom_url})
            }catch(error){
                console.log(error)
            }finally{
                if (isMounted) {
                    // Only update state if the component is still mounted
                    setLoading(false);
                }
            }
        }

        if(fetchedData){
            fetchData();
            if(window.innerWidth <= mobileViewWidth){
                window.scrollTo({
                    top: 1,
                    behavior: 'instant'
                });
            } else {
                if (containerRef.current) {
                    containerRef.current.scrollTo({
                    top: 0,
                    behavior: 'instant'
                    });
                }
            }
        }

        return () => {
            isMounted = false; // Mark the component as unmounted
        };
    },[fetchedData]);

    return (
        <>
            <AllMeta
                title={t('tyreBrandModelPage_meta_title', {brandMmodel: fetchedData?.name})}
                description={t('tyreBrandModelPage_meta_description', {brandMmodel: fetchedData?.name})}
                keyword={t('tyreBrandModelPage_meta_keyword', {brandMmodel: fetchedData?.name})}
                image={!_.isEmpty(fetchedData?.image_path) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.image_path}` : undefined}
            />
            <Head><title>{t('tyreBrandModelPage_title', {brandMmodel: fetchedData?.name})}</title></Head>
            <MyBody
                t={t}
                headerComponent={
                    <HeaderBack t={t} />
                }
            >
                <TyreModelVariant t={t} imagePath={fetchedData?.image_path} loading={loading} scrollView={_scrollView} />
                <div className="containerPadding">
                    <p className="fontSize_20 fontWeight_bold tyreModel_modelTitle">
                        {fetchedData?.brand_name}
                    </p>
                    <p className="fontSize_16 fontWeight_bold tyreModel_modelSubtitle">
                        {_modelName(fetchedData?.brand_name, fetchedData?.name)}
                    </p>
                    <div className="vehicleModel_specList">
                        <TyreSpecBox t={t} image={"/assets/images/icon/vehicle_body_icon.png"} label={t("body_type")} input={`${fetchedData?.body_type}`} displayBottom={false} scrollView={_scrollView} imageType={'image'}/>
                        <TyreSpecBox t={t} image={<TyreIcon />} label={t("tyre_sizes")} input={`${fetchedData?.available_inches_string}`} displayBottom={true} scrollView={_scrollView} imageType={'svg'}/>
                    </div>
                </div>
                <TyreRatingBox t={t} drygrip_braking={fetchedData?.drygrip_braking} wetgrip_braking={fetchedData?.wetgrip_braking} longevity={fetchedData?.longevity} silence_comfort={fetchedData?.silence_comfort}/>
                <TyreDescription t={t} description={fetchedData?.description} lineClamp={lineClamp} viewmore={viewMore} setViewMore={() => { _setViewMore() }} />
                <TyreUserReviewSection 
                    fetchedData={fetchedData} 
                    userReviewList={userReviewList} 
                    t={t}
                    router={router}
                    loading={loading}
                    isLogin={isLogin}
                />
                <div className="tyreVariantBox_sec" style={{ paddingTop: '1.5rem' }}>
                    <TyreVariantBox t={t} available_inches={JSON.parse(fetchedData?.available_inches)} data={tyreVariant} loading={loading} />
                </div>
                <div className='mt_25'>
                    <PlacementBanner
                        // can't pass object because inside using memo
                        loading={store?.path?.dataPlacement == undefined ? true : false}
                        area={placementArea?.tyreModel_detailPage} 
                        placement_id={store?.path?.dataPlacement?.[placementArea?.tyreModel_detailPage]?.placement_id}
                        type={store?.path?.dataPlacement?.[placementArea?.tyreModel_detailPage]?.type}
                        image_path={store?.path?.dataPlacement?.[placementArea?.tyreModel_detailPage]?.image_path}
                        url={store?.path?.dataPlacement?.[placementArea?.tyreModel_detailPage]?.url}
                        script={store?.path?.dataPlacement?.[placementArea?.tyreModel_detailPage]?.script}
                    />
                </div>
                <PopularTyreBrands data={store?.path?.dataAllTyreTopList?.brand ?? []} isSingleRow={false} t={t} loading={store?.path?.dataAllTyreTopList == undefined ? true : false} isTyreDetail={true} />
                <PopularCarBrands t={t} data={store?.path?.dataAllVehicleTopList?.brand} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         <AllMeta
    //             title={t('tyreBrandModelPage_meta_title', {brandMmodel: fetchedData?.name})}
    //             description={t('tyreBrandModelPage_meta_description', {brandMmodel: fetchedData?.name})}
    //             keyword={t('tyreBrandModelPage_meta_keyword', {brandMmodel: fetchedData?.name})}
    //             image={!_.isEmpty(fetchedData?.image_path) ? `${process.env.NEXT_PUBLIC_FS_URL}${fetchedData?.image_path}` : undefined}
    //         />
    //         <Head><title>{t('tyreBrandModelPage_title', {brandMmodel: fetchedData?.name})}</title></Head>
    //         <div className='bodyContainer'>
    //             <div className='contentContainer'>
    //                 <HeaderBack t={t} />
    //                 <TyreModelVariant t={t} imagePath={fetchedData?.image_path} loading={loading} scrollView={_scrollView} />
    //                 <div className="containerPadding">
    //                     <p className="fontSize_20 fontWeight_bold tyreModel_modelTitle">
    //                         {fetchedData?.brand_name}
    //                     </p>
    //                     <p className="fontSize_16 fontWeight_bold tyreModel_modelSubtitle">
    //                         {_modelName(fetchedData?.brand_name, fetchedData?.name)}
    //                     </p>
    //                     <div className="vehicleModel_specList">
    //                         <TyreSpecBox t={t} image={"/assets/images/icon/vehicle_body_icon.png"} label={t("body_type")} input={`${fetchedData?.body_type}`} displayBottom={false} scrollView={_scrollView} imageType={'image'}/>
    //                         <TyreSpecBox t={t} image={<TyreIcon />} label={t("tyre_sizes")} input={`${fetchedData?.available_inches_string}`} displayBottom={true} scrollView={_scrollView} imageType={'svg'}/>
    //                     </div>
    //                 </div>
    //                 <TyreRatingBox t={t} drygrip_braking={fetchedData?.drygrip_braking} wetgrip_braking={fetchedData?.wetgrip_braking} longevity={fetchedData?.longevity} silence_comfort={fetchedData?.silence_comfort}/>
    //                 <TyreDescription t={t} description={fetchedData?.description} lineClamp={lineClamp} viewmore={viewMore} setViewMore={() => { _setViewMore() }} />
    //                 <TyreUserReviewSection 
    //                     fetchedData={fetchedData} 
    //                     userReviewList={userReviewList} 
    //                     t={t}
    //                     router={router}
    //                     loading={loading}
    //                     isLogin={isLogin}
    //                 />
    //                 <div className="tyreVariantBox_sec" style={{ paddingTop: '1.5rem' }}>
    //                     <TyreVariantBox t={t} available_inches={JSON.parse(fetchedData?.available_inches)} data={tyreVariant} loading={loading} />
    //                 </div>
    //                 <div className='mt_25'>
    //                     <PlacementBanner
    //                         // can't pass object because inside using memo
    //                         loading={store?.path?.dataPlacement == undefined ? true : false}
    //                         area={placementArea?.tyreModel_detailPage} 
    //                         placement_id={store?.path?.dataPlacement?.[placementArea?.tyreModel_detailPage]?.placement_id}
    //                         type={store?.path?.dataPlacement?.[placementArea?.tyreModel_detailPage]?.type}
    //                         image_path={store?.path?.dataPlacement?.[placementArea?.tyreModel_detailPage]?.image_path}
    //                         url={store?.path?.dataPlacement?.[placementArea?.tyreModel_detailPage]?.url}
    //                         script={store?.path?.dataPlacement?.[placementArea?.tyreModel_detailPage]?.script}
    //                     />
    //                 </div>
    //                 <PopularTyreBrands data={store?.path?.dataAllTyreTopList?.brand ?? []} isSingleRow={false} t={t} loading={store?.path?.dataAllTyreTopList == undefined ? true : false} isTyreDetail={true} />
    //                 <PopularCarBrands t={t} data={store?.path?.dataAllVehicleTopList?.brand} loading={store?.path?.dataAllVehicleTopList == undefined ? true : false} />
    //                 <Footer t={t} />
    //             </div>
    //         </div>
    //     </>
    // )
}